<script>
  import { modal } from 'vue-strap';
  import ProtocolosConteiner from '~modulos/relatorio/componentes/ProtocolosConteiner.vue';
  import relatorioServico from '~modulos/relatorio/relatorio.servico';
  
  export default {
    components: { modal, ProtocolosConteiner },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      numeroProtocolo: {
        required: true,
      },
    },
    data() {
      return {
        carregando: true,
        relatorio: [],
      }
    },
    methods: {
      carregar() {
        this.carregando = true;
        
        relatorioServico
          .protocolos(this.numeroProtocolo)
          .then(resultado => {
            this.relatorio = resultado;
            
            this.carregando = false;
          });
      }
    },
    computed: {
      show() {
        return this.mostrar;
      },
    },
  }
</script>

<template>
  <div>

    <modal
      ref="modal"
      :value="show"
      effect="fade"
      @closed="relatorio = [], $emit('fechado')"
      @opened="carregar"
      :large="true">
      <div slot="modal-header" class="modal-header">Protocolo #{{ numeroProtocolo }}</div>

      <div v-if="carregando" class="text-center">
        <i class='fa fa-spinner fa-pulse'></i> Carregando...
      </div>
      
      <protocolos-conteiner :relatorio="relatorio" v-if="!carregando && relatorio.length > 0"></protocolos-conteiner>

      <slot name="extra"></slot>

      <div slot="modal-footer" class="modal-footer">
        <button
          type="button"
          class="btn btn-default"
          @click="$refs.modal.action(false, 3)">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/ModalProtocolos.vue